module.exports = __webpack_public_path__ + "static/bristol-cc-black-f0c2afab499ecf6d2d0e29570c75fca5.png";